export default "__VITE_ASSET__Dltj3e_i__"